import format from 'date-fns/format'

function downloadFile(
  fileUrl,
  filenamePrefix = 'getuniq',
  fileExtension = 'pdf',
) {
  const token = localStorage.getItem('access_token')
  const switchedUser = localStorage.getItem('su')
  const date = new Date()
  const [hour, minutes] = [date.getHours(), date.getMinutes()]
  let filename = null

  const config = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  if (switchedUser) {
    config.headers['X-Switch-User'] = switchedUser
  }

  return fetch(fileUrl, config)
    .then((response) => {
      let disposition = response.headers.get('Content-Disposition')
      if (disposition && disposition.indexOf('inline') !== -1) {
        let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        let matches = filenameRegex.exec(disposition)
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '')
        }
      }

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`)
      }
      return response.blob()
    })
    .then((blob) => {
      const downloadUrl = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = downloadUrl
      link.download =
        filename ||
        `${filenamePrefix}--${format(
          date,
          'dd.MM.yyyy',
        )}-${hour}.${minutes}.${fileExtension}`
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(downloadUrl)
    })
}

export default downloadFile
